export interface SignupData {
    id: any;
    title: string;
    path?:string;
    icon?:any;
}

export const signUpData : SignupData [] = [
    {
        id: '1',
        title: 'Personal',
        icon: require ("../../../assets/images/sign-up/signUpCard/user.png"),
        path:"/authentication/personal_signup",
    },
    {
        id: '2',
        title: 'Corporate',
        icon: require ("./../../../assets/images/sign-up/signUpCard/corporate.png"),
        path:"/authentication/signup",
    },
    {
        id: '3',
        title: 'Commercial',
        icon: require ("./../../../assets/images/sign-up/signUpCard/commercial.png"),
        path:"/authentication/signup",
    },
    {
        id: '4',
        title: 'ThirdParty',
        icon: require ("./../../../assets/images/sign-up/signUpCard/thirdParty.png"),
        path:"/authentication/third_party_signup",
    },
    {
        id: '5',
        title: 'Lawyers',
        icon: require ("./../../../assets/images/sign-up/signUpCard/lawyer.png"),
        path:"/authentication/lawyers_signup",
    },
]